/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Focus_TextInputs */

const en_funnel_ob_ben_focus_text = /** @type {(inputs: Funnel_Ob_Ben_Focus_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loss aversion shapes how we weigh risk and reward.`)
};

const es_funnel_ob_ben_focus_text = /** @type {(inputs: Funnel_Ob_Ben_Focus_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La aversión a la pérdida moldea cómo evaluamos el riesgo y la recompensa.`)
};

/**
* | output |
* | --- |
* | "Loss aversion shapes how we weigh risk and reward." |
*
* @param {Funnel_Ob_Ben_Focus_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_focus_text = /** @type {((inputs?: Funnel_Ob_Ben_Focus_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Focus_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_focus_text(inputs)
	return en_funnel_ob_ben_focus_text(inputs)
});